var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"fab":"","x-small":"","outlined":"","color":"grey"}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.mdiCalendar))])],1)]}}])},[_c('span',[_vm._v("This number will be transfered on "+_vm._s(_vm._f("formatDate")(_vm.confirmedTransferDate)))])])}
var staticRenderFns = []

export { render, staticRenderFns }